module.exports = __webpack_public_path__ + "img/indexBg2.776ff645.png";